import { Component, OnInit } from '@angular/core';
import { JhiCapitalizePipe } from 'ng-jhipster';

import {
    Session,
    SessionProposal,
    SessionProposalService,
} from '../../../_services';

@Component({
    selector: 'last-proposal-answers',
    templateUrl: 'proposal.component.html',
    styleUrls: ['proposal.component.scss'],
    providers: [JhiCapitalizePipe],
})
export class LastProposalAnswersComponent implements OnInit {
    standardSessionProposalAnswers: SessionProposal[];
    virtualSessionProposalAnswers: SessionProposal[];
    session: Session;

    checkSessionId = function (sessionProposal: SessionProposal) {
        return sessionProposal.sessionId !== null;
    };

    checkVirtualSessionId = function (sessionProposal: SessionProposal) {
        return sessionProposal.virtualSessionId !== null;
    };

    constructor(private sessionProposalService: SessionProposalService) {}

    ngOnInit() {
        this.fetch();
    }

    fetch() {
        this.sessionProposalService
            .findLastTrainerSessionProposalAnswers(5)
            .subscribe((sessionProposalAnswers) => {
                this.standardSessionProposalAnswers =
                    sessionProposalAnswers.filter(this.checkSessionId);
                this.virtualSessionProposalAnswers =
                    sessionProposalAnswers.filter(this.checkVirtualSessionId);
            });
    }

    evaluateType(type: string) {
        if (type === 'PUBLIC') {
            return 'Inter';
        }
        return 'Intra';
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing-answers/proposal.component.ts